import { defineAsyncComponent } from 'vue';

const NeosoftDashboardProjectsFilters = defineAsyncComponent(() => import('@/client_customs/Neosoft/NeosoftDashboardProjectsFilters.vue'));

export default {
  subdomain: 'neosoft',
  clientCustomComponents: { NeosoftDashboardProjectsFilters },
  hideManageAccount: true,
  sso: {
    protocol: 'openIDConnect',
    login: 'https://login.microsoftonline.com/09b07065-15c8-4f56-812c-e223c6d8bd2d/oauth2/v2.0/authorize?client_id=cd87c57e-f299-47b6-85de-0164be7be888&response_type=code&scope=openid%20email%20profile&redirect_uri=https%3A%2F%2Fneosoft.bubbleplan.net',
    response_type: 'code',
  },
  startupScript() {
    import('../../Neosoft/neosoft.scss');
  },
  kanban: {
    showPlannedMilestonesInBacklog: true,
  },
  projects: {
    categoriesANDFilter: true,
  },
  dashboards: {
    customProjectsFilters: { component: 'NeosoftDashboardProjectsFilters', value: {} }, // value is used as a store
  },
  colors: [
    { label: "INFRA", sublabels: ["INFRA Standard", "", "", "", "INFRA Exceptionnel"] },
    { label: "P&I", sublabels: ["P&I Standard", "", "", "", "P&I Exceptionnel"] },
    { label: "SAT", sublabels: ["SAT Standard", "", "", "", "SAT Exceptionnel"] },
    { label: "SSI", sublabels: ["SSI Standard", "", "", "", "SSI Exceptionnel"] },
    { label: "DTI", sublabels: ["", "", "", "", ""] },
    { label: "GROUPE", sublabels: ["Direction", "RH", "Juridique", "Comm/Marketing", "Finances"] },
    { label: "GROUPE", sublabels: ["Commerce", "Bid", "Agences", "", ""] },
  ],
  icons: {
    replace: {
      rocketBlue: { name: 'fas fa-rocket', color: 'primary', label: 'Lancement planifié' },
      rocket: { name: 'fas fa-rocket', color: 'successgreen', label: 'Lancement effectué' },
      milestone0: { name: 'fak fa-bbp-milestone', color: 'primary', label: 'Jalon planifié' },
      milestone2: { name: 'fak fa-bbp-milestone', color: 'successgreen', label: 'Jalon respecté' },
      milestone1: { name: 'fak fa-bbp-milestone', color: 'warningorange', label: 'Jalon en alerte' },
      milestone3: { name: 'fak fa-bbp-milestone', color: 'errorred', label: 'Jalon en retard' },

      endflagBlue: { name: 'fas fa-flag-checkered', color: 'primary', label: 'Fin de projet planifiée' },
      endflagGreen: { name: 'fas fa-flag-checkered', color: 'successgreen', label: 'Fin de projet respectée' },
      endflag: { name: 'fas fa-flag-checkered', color: 'warningorange', label: 'Fin de projet en alerte' },
      endflagRed: { name: 'fas fa-flag-checkered', color: 'errorred', label: 'Fin de projet en retard' },
      digging: { name: 'fas fa-digging', color: 'warningorange', label: 'A construire' },
      binoculars: { name: 'fas fa-binoculars', color: 'primary', label: 'Envisagé' },

      danger: { name: 'fas fa-times-circle', color: 'errorred', label: 'A l\'arrêt' },
      warning: { name: 'fas fa-exclamation-triangle', color: 'warningorange', label: 'Point dur' },
      done: { name: 'fas fa-check-circle', color: 'successgreen', label: 'Traité' },
      question: { name: 'fas fa-question-circle', color: 'primary', label: 'A arbitrer' },
      information: { name: 'fas fa-info-circle', color: 'primary', label: 'Pour info' },
      forbidden: { name: 'fas fa-minus-circle', color: 'errorred', label: 'Echec ou Abandon' },

      trophy: { name: 'fas fa-trophy', color: 'successgreen', label: 'Victoire !' },
      handshakeBlue: { name: 'fas fa-handshake', color: 'primary', label: 'Contractualisation prévue' },
      handshake: { name: 'fas fa-handshake', color: 'successgreen', label: 'Contractualisation signée' },
      halt: { name: 'fas fa-hand-paper', color: 'errorred', label: 'Attendre' },
      flag: { name: 'fas fa-flag', color: 'successgreen', label: 'Objectif atteint' },
      placeholder1: {},

      position: { name: 'fas fa-map-marker-alt', color: 'darkgrey', label: 'Localisation' },
      route: { name: 'fas fa-route', color: 'warningorange', label: 'Déplacement nécessaire' },
      leaf: { name: 'fas fa-leaf', color: 'successgreen', label: 'Action écologique' },
      socialAction: { name: 'fas fa-handshake-angle', color: 'successgreen', label: 'Action sociale' },
      placeholder2: {},
      placeholder3: {},

      sitemap: { name: 'fas fa-sitemap', color: 'darkgrey', label: 'Réseau' },
      laptop: { name: 'fas fa-laptop', color: 'darkgrey', label: 'Materiel informatique' },
      mobile: { name: 'fas fa-mobile-alt', color: 'darkgrey', label: 'Materiel téléphonique' },
      admin: { name: 'fas fa-user-shield', color: 'darkgrey', label: 'Sécurisation' },
      manager: { name: 'fas fa-user-tie', color: 'darkgrey', label: 'Audit process' },
      secret: { name: 'fas fa-user-secret', color: 'darkgrey', label: 'Audit sécurité' },

      book: { name: 'fas fa-book', color: 'darkgrey', label: 'Documentation' },
      euro: { name: 'fas fa-euro-sign', color: 'warningorange', label: 'Financier' },
      cog: { name: 'fas fa-cog', color: 'darkgrey', label: 'Paramétrage' },
      database: { name: 'fas fa-database', color: 'darkgrey', label: 'Données' },
      comment: { name: 'fas fa-comment', color: 'darkgrey', label: 'Commentaires' },
      tasks: { name: 'fas fa-tasks', color: 'darkgrey', label: 'Listes d\'actions' },

      phone: { name: 'fas fa-phone', color: 'primary', label: 'Contacter' },
      email: { name: 'fas fa-envelope', color: 'primary', label: 'Informer' },
      talk: { name: 'fas fa-bullhorn', color: 'primary', label: 'Annoncer largement' },
      share: { name: 'fas fa-share', color: 'successgreen', label: 'A partager' },
      buld: { name: 'fas fa-lightbulb', color: 'warningorange', label: 'Idée' },
      lightbuld: { name: 'fas fa-lightbulb-on', color: 'successgreen', label: 'Idée validée' },

      clock: { name: 'fas fa-clock', color: 'info', label: 'Planning' },
      time: { name: 'fas fa-hourglass-half', color: 'warningorange', label: 'Temporisation' },
      alarm: { name: 'fas fa-alarm-clock', color: 'warningorange', label: 'Alerte temporelle' },
      stats: { name: 'fas fa-chart-pie', color: 'primary', label: 'Reporting' },
      chartline: { name: 'fas fa-chart-line', color: 'primary', label: 'Avancement' },
      industry: { name: 'fas fa-industry', color: 'successgreen', label: 'Production / Run' },

      appreciation: { name: 'fas fa-thumbs-up', color: 'successgreen', label: 'Bravo !' },
      bad: { name: 'fas fa-thumbs-down', color: 'errorred', label: 'A revoir !' },
      presentation: { name: 'fas fa-presentation', color: 'successgreen', label: 'Présentation' },
      conference: { name: 'fas fa-users-class', color: 'info', label: 'Réunion' },
      lock: { name: 'fas fa-lock', color: 'errorred', label: 'Verrouillé' },
      unlock: { name: 'fas fa-unlock-alt', color: 'successgreen', label: 'Libéré' },

      sync: { name: 'fas fa-sync', color: 'successgreen', label: 'Recyclage' },
      calendar: { name: 'fas fa-calendar-alt', color: 'info', label: 'Calendrier' },
      newDate: { name: 'fas fa-calendar-plus', color: 'successgreen', label: 'Réparation/Correction' },
      gift: { name: 'fas fa-gift', color: 'successgreen', label: 'Surprise !' },
      user: { name: 'fas fa-user', color: 'primary', label: 'Individuel' },
      users: { name: 'fas fa-users', color: 'successgreen', label: 'Groupe' },

      sun: { name: 'fas fa-sun', color: 'warningorange', label: 'Météo ensoleillée' },
      sunCloud: { name: 'fas fa-cloud-sun', color: 'info', label: 'Météo mitigée' },
      rain: { name: 'fas fa-cloud-rain', color: 'primary', label: 'Météo pluvieuse' },
      storm: { name: 'fas fa-poo-storm', color: 'errorred', label: 'Météo en crise' },
    },
    disableRenaming: true,
  },
};
